import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { types, setError } from "../../store/actions"; // Assuming types and setError are available
import { ERROR_TYPES, ERROR_NETWORK_DISCONNECTED } from "../constants/errorConstants";

export const useNetworkMonitor = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Handler for when the connection is lost
    const handleOffline = () => {
      console.warn("Client is OFFLINE. Dispatching warning.");
      dispatch(
        setError({
          message: ERROR_NETWORK_DISCONNECTED,
          errorType: ERROR_TYPES.WARNING // Use WARNING to show the NotificationBanner
        })
      );
    };

    // Handler for when the connection is restored
    const handleOnline = () => {
      console.info("Client is ONLINE. Clearing errors.");
      // Dispatch a success/clear action to remove the warning notification
      dispatch({ type: types.CLEAR_ERROR_MESSAGE });
    };

    // Add listeners to the global window object
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    // CRITICAL: Check initial state upon mounting
    if (!navigator.onLine) {
      handleOffline();
    }

    // Cleanup function to remove listeners when the hook unmounts
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, [dispatch]);
};
